import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { fullValidateRegex } from "../../../utils/acquisition-utils";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { TFieldValidationResult } from "./CtaFieldValidations.types";
import { isFieldInvalid } from "./CtaFieldValidations.utils";


export const personalInformationFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResults: TFieldValidationResult = {};
    
    if (hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')){
        const {
            firstName,
            lastName,
            emailAddress,
            dateOfBirthDay,
            dateOfBirthMonth,
            dateOfBirthYear,
            mailingAddressLineOne,
            mailingAddressLineTwo,
            mailingAddressCity,
            mailingAddressState,
            mailingAddressZipCode,
            homeAddressLineOne,
            homeAddressLineTwo,
            homeAddressCity,
            homeAddressState,
            homeAddressZipCode,
        } = validatingState.getPersonalInformation();

        // Applicant Name
        if (isFieldInvalid(firstName) || !fullValidateRegex('first_name', firstName.value)) {
            validationResults['FirstName'] = 'RequiredField';
        }
        if (isFieldInvalid(lastName) || !fullValidateRegex('last_name', lastName.value)) {
            validationResults['LastName'] = 'RequiredField';
        }
    
        // Mailing Address
        if (isFieldInvalid(mailingAddressLineOne)) {
            validationResults['MailingAddressLine1'] = 'RequiredField';
        }
        if (isFieldInvalid(mailingAddressCity)) {
            validationResults['MailingCity'] = 'RequiredField'
        }
        if (isFieldInvalid(mailingAddressState)) {
            validationResults['MailingState'] = 'RequiredField';
        }
        if (isFieldInvalid(mailingAddressZipCode)) {
            validationResults['MailingZipCode'] = 'RequiredField';
        }
    
        if (mailingAddressLineOne.value === mailingAddressLineTwo.value) {
            validationResults['AddrAndAptNumMatch'] = 'NotValid';
        }
    
        // Home Address
        const validateHomeAddress = validatingState.getIsHomeAddressShown();
        if (validateHomeAddress) {
            if (isFieldInvalid(homeAddressLineOne)) {
                validationResults['HomeAddressLine1'] = 'RequiredField';
            }
            if (isFieldInvalid(homeAddressCity)) {
                validationResults['HomeCity'] = 'RequiredField';
            }
            if (isFieldInvalid(homeAddressState)) {
                validationResults['HomeState'] = 'RequiredField';
            }
            if (isFieldInvalid(homeAddressZipCode)) {
                validationResults['HomeZipCode'] = 'RequiredField';
            }

            if (homeAddressLineOne.value === homeAddressLineTwo.value) {
                validationResults['HomeAddrAndAptNumMatch'] = 'NotValid';
            }

            if (mailingAddressLineOne.value === homeAddressLineOne.value) {
                validationResults['IsMailingHomeAddressSame'] = 'NotValid';
            }
        }

        // Email Address
        if (
            isFieldInvalid(emailAddress)
        ) {
            validationResults['EmailAddress'] = 'RequiredField'
        }

        // Date of Birth
        if (
            isFieldInvalid(dateOfBirthDay) 
            || isFieldInvalid(dateOfBirthMonth) 
            || isFieldInvalid(dateOfBirthYear)
        ) {
            validationResults['DateOfBirth'] = 'RequiredField';
        }
    }

    return validationResults;
}

export const ssnFieldValidation = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResult: TFieldValidationResult = {};
    if (hasDefaultComponent('cob-corp-acquisition/components/creditonebank/ssn-module')) {
        const { isSsnInfoValid, ssnInfo } = validatingState.getSsn();
        if (!isSsnInfoValid) {
            validationResult['Ssn'] = 'RequiredField';
        }
        if (!ssnInfo) {
            validationResult['Ssn'] = 'RequiredField';
        }
        if (ssnInfo && ssnInfo.length < 9) {
            validationResult['Ssn'] = 'NotValid';
        }
    }
    if (hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')){
        const {
            ssn
        } = validatingState.getPersonalInformation();
        if (isFieldInvalid(ssn)) {
            validationResult['Ssn'] = 'RequiredField';
        }
        if (ssn?.value && ssn.value.length > 0 && ssn.value.length < 9) {
            validationResult['Ssn'] = 'NotValid';
        }
    }
    return validationResult;
}